import { render, staticRenderFns } from "./moralEducation.vue?vue&type=template&id=03835472&scoped=true"
import script from "./moralEducation.vue?vue&type=script&lang=js"
export * from "./moralEducation.vue?vue&type=script&lang=js"
import style0 from "./moralEducation.vue?vue&type=style&index=0&id=03835472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03835472",
  null
  
)

export default component.exports